import React from 'react';
import { PapiBadge } from '@wix/da-papi-types';
import Flex from '@wix/da-ds/pkg/Flex';
import SpotlightBadge from '../../_partials/SpotlightBadge';

import s from './BadgesSpotlight.scss';

export interface Props {
  moduleId: number;
  badges: PapiBadge[];
}

const BadgesSpotlight: React.FC<Props> = ({ badges }) => {
  return (
    <Flex className={s['root']} justifyContent="center" wrap="wrap">
      {badges.map(b => (
        <SpotlightBadge key={b.id} badge={b} />
      ))}
    </Flex>
  );
};
BadgesSpotlight.displayName = 'BadgesSpotlight';

export default BadgesSpotlight;
